var $ = require("./lib/qsa");
var pym = require("./lib/pym");
var pymChild;
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var dot = require("./lib/dot");
var templateSource = require("./partials/_new_table.html");
var template = dot.compile(templateSource);
var data = window.DATA;

async function init() {
  if (window.location.hostname == "apps.npr.org") {
    // console.log("yeet")
    var request = await fetch("https://apps.npr.org/dailygraphics/data/sheets/jan-6-subpoena-tracker-20211101.json");
    var copy = await request.json();

      data = copy.data;
      var tableContent = template(data);
      var tableEl = $.one("#table-total");

      tableEl.innerHTML = tableContent;
    }

    pymChild.sendHeight();
  };

var onWindowLoaded = function() {
  pym.then(child => {
    pymChild = child;

    init();
    // chainFilters();

    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

window.onload = onWindowLoaded;

var controls = $.one(".controls");
var categoryList = $.one("#categories-drop");
var searchBox = $.one("#search");
var tableContainer = $.one("#table-total");

var filterByCategory = function(cat, list) {
  if (!cat) {
    return list;
  }

  console.log(list)

  return list.filter(function(row) {
    return row[cat];
  })
}

var filterBySearch = function (query, list) {
  if (!query) {
    return list;
  }
  var re = new RegExp(query, "i");
  return list.filter(
    (r) =>
      r.name.match(re) ||
      r.role.match(re)
  );
}

var chainFilters = function() {
  // console.log("yeet")
  var filters = [
    { filter: filterByCategory, value: categoryList.value }
    // { filter: filterBySearch, value: searchBox.value }
  ];

  var rows = data;
  // console.log(data)
  filters.forEach((def) => (rows = def.filter(def.value, rows)));
  // rows.sort((a, b) => a.subpoena_issued - b.subpoena_issued);
  // console.log(rows)

  tableContainer.innerHTML = template(rows);

  if (pymChild) {
    pymChild.sendHeight();
  }
}

// console.log(allData)
chainFilters();

var debounce = require("./lib/debounce");

var debounceFilters = debounce(chainFilters);
controls.addEventListener("input", debounceFilters);
